var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.96 4.38C2.24 2.91 3.62 1.9 5.12 1.9h2.93c.52 0 .95-.43.95-.95S8.57 0 8.05 0H5.22C2.61 0 .28 1.91.03 4.51A4.995 4.995 0 0 0 5 10h3.05c.52 0 .95-.43.95-.95s-.43-.95-.95-.95H5a3.11 3.11 0 0 1-3.04-3.72ZM7 6h6c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1Zm7.78-6h-2.83c-.52 0-.95.43-.95.95s.43.95.95.95h2.93c1.5 0 2.88 1.01 3.16 2.48A3.11 3.11 0 0 1 15 8.1h-3.05c-.52 0-.95.43-.95.95s.43.95.95.95H15c2.92 0 5.26-2.51 4.98-5.49-.25-2.6-2.59-4.51-5.2-4.51Z",
    fill: "#FFF"
  })));
};
export default SvgLink;